import { Route, Routes } from "react-router-dom"
import Login from "@/pages/noauth/LoginForm/Login"
import NotFound from "@/components/NotFound"

const PublicRoutes = () => {
    return (
        <Routes>
            <Route path={'*'} Component={NotFound}/>
            <Route path={'/'} Component={Login} />
        </Routes>
    )
}

export default PublicRoutes